import React, {useState, useEffect} from 'react';
import {onAuthStateChanged, GoogleAuthProvider, signInWithPopup} from 'firebase/auth';
import {AdminTools} from './AdminTools';
import {RsvpForm} from './RsvpForm';
import './styles.scss';

export function Page({auth, database}) {
    const [searchInput, setSearchInput] = useState('');
    const [disableSearch, setDisableSearch] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    function searchForRsvp(e) {
        e.preventDefault();

        setShowForm(true);
        setDisableSearch(true);
    }

    function clearSearchInput() {
        setShowForm(false);
        setDisableSearch(false);
    }

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
          if (user && user.uid == 'W3N2D1vOjOZviTV4ioCXv4NJBi43') {
            setIsAdmin(true);
          } else {
            console.log('Not logged in...');
          }
        });
    });

    async function adminSignIn() {
        const provider = new GoogleAuthProvider();

        await signInWithPopup(auth, provider);
    }

    return (
        <section className='page'>
            <img className='hero' src='./images/hero.svg'/>
            <img className='wedding' src='./images/wedding.png'/>
            <div className='rsvp-search'>
                <form onSubmit={searchForRsvp}>
                    <label>
                        Find your RSVP:
                        <input 
                            disabled={disableSearch}
                            type='text'
                            placeholder='First Name Last Name'
                            value={searchInput}
                            onChange={e => setSearchInput(e.target.value)}
                            />
                    </label>
                </form>
                {!disableSearch && <button onClick={searchForRsvp}>Search</button>}
                {disableSearch && <button onClick={clearSearchInput}>Clear</button>}
            </div>
            {showForm && <RsvpForm database={database} searchInput={searchInput}/>}
            {isAdmin && <AdminTools database={database}/>}
            <a target='_blank' href='https://withjoy.com/chase-and-halen/registry'>Visit Our Registry<span>&rarr;</span></a>
            <footer>Technical difficulties? Text Chase, he made the website!</footer>
            <img className='heart top-left' src='./images/heart.gif'/>
            <img className='heart top-right' src='./images/heart.gif'/>
            <img className='heart bottom-left' src='./images/heart.gif'/>
            <img className='heart bottom-right' src='./images/heart.gif'/>
            <button className='admin-sign-in' onClick={adminSignIn}>Admin Sign-In</button>
        </section>
    );
}
